<div style="flex: 1; width: 100%; border: 1px solid #ccc; border-radius: 5px; padding: 10px; background-color: #fff; position: relative; box-sizing: border-box; display: flex; flex-direction: column;">
    <div style="margin-bottom: 15px; display: flex; justify-content: flex-start;">
        <button pButton icon="pi pi-arrow-right" (click)="enviarDados()" class="p-button-primary"></button>
    </div>
</div>
<div style="margin-top: 3%;">
    <!-- Botão para enviar os dados -->

    <div style="flex: 1; width: 100%; border: 1px solid #ccc; border-radius: 5px; padding: 20px; background-color: #fff; position: relative; box-sizing: border-box; display: flex; flex-direction: column;">
        <!-- Título na borda -->
        <div style="position: absolute; top: -10px; left: 10px; background-color: #fff; padding: 0 5px; font-size: 14px; color: #555;">
            Parâmetros Teste
        </div>

        <!-- Campo Empresa Fixo -->
        <div *ngIf="empresaField" style="margin-bottom: 15px; width: 100%;">
            <label for="empresa" style="font-weight: bold;">{{ empresaField.campo.replace('_', ' ') }}</label>
            <p-multiSelect
              [options]="empresas"
              [(ngModel)]="empresaField.valor"
              optionLabel="nome" 
              optionValue="id"
              display="chip"
              [showHeader]="true"
              [filter]="true"
              [filterPlaceHolder]="'Buscar...'"
              [style]="{ width: '100%', height: '40px' }"
              appendTo="body"
            ></p-multiSelect>
          </div>
          

        <!-- Campos Dinâmicos -->
        <div *ngIf="fields.length > 0" class="dynamic-fields-container">
            <div
                *ngFor="let field of fields"
                class="dynamic-field-item"
            >
                <label [for]="field.campo" style="font-weight: bold;">{{ field.campo.replace('_', ' ') }}</label>
            
                <!-- Date -->
                <ng-container *ngIf="field.tipo === 'date'">
                    <p-calendar
                        id="{{ field.campo }}"
                        [(ngModel)]="field.valor"
                        dateFormat="dd/mm/yy"
                        [showTime]="true"
                        [style]="{ width: '100%' }"
                    ></p-calendar>
                </ng-container>
                
                <!-- Number -->
                <ng-container *ngIf="field.tipo === 'number'">
                    <p-inputNumber
                        id="{{ field.campo }}"
                        [(ngModel)]="field.valor"
                        [style]="{ width: '100%' }"
                    ></p-inputNumber>
                </ng-container>
            
                <!-- Text -->
                <ng-container *ngIf="field.tipo === 'text'">
                    <input
                        id="{{ field.campo }}"
                        [(ngModel)]="field.valor"
                        [style]="{ width: '100%' }"
                    />
                </ng-container>
            </div>
        </div>
    </div>
</div>
